import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Curtain = ({ children }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1, transition: { duration: 0.4, ease: EASE } }}
    exit={{ opacity: 0, transition: { duration: 0.25 } }}
  >
    {children}
  </motion.div>
);

export const FadeSlide = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 14 }}
    animate={{ opacity: 1, y: 0, transition: { duration: 0.35, ease: EASE } }}
    exit={{ opacity: 0, y: -8, transition: { duration: 0.18 } }}
  >
    {children}
  </motion.div>
);
